import { useSelector } from 'react-redux';
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import useLoadingPercentage from './useLoadingPercentage';

const useMedicalSummaryLoadingPercentage = () => {
  const { generateSummaryUpdateTime } = useAddCaseFormContext();

  const socketLoadingPercentage = useSelector(state => state.preProcessMedicalRecords.summaryLoadingPercentage);
  const proccessedMedicalRecordsStored = useSelector(state => state.preProcessMedicalRecords.injuryData);

  const { loadingValue: summaryLoadingPercentage } = useLoadingPercentage(generateSummaryUpdateTime, 10, socketLoadingPercentage === 100, false);

  return {
    isPreProcessRecordLoading: proccessedMedicalRecordsStored?.isPreProcessRecordLoading,
    summaryLoadingPercentage,
  };
};

export default useMedicalSummaryLoadingPercentage;
